import router from './router'
import store from './store'
import secret from './utils/secret'
import utils from './utils/utils'
import { getToken, setToken, setRedirectUrl, getConsumerCondition,getRedirectUrl} from '@/utils/cookies'

const defaultJumpRouter = ['/indexs', '/tradition', '/design', '/bexam', '/garden', '/interiordesign', '/bim', '/build','/secondEffieicient','/search']
// const traditionBuildRouter = ['/index', '/xszt', '/zxsc', '/zxkc', '/hyfw']
const defaultJumpReadPlatform = [, '/mechanism']
const DEFAULT_PLATFORM_PATH = process.env.PLATFORM_PATH
const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH
const CTJZ_PLATFORM_PATH = process.env.CTJZ_PLATFORM_PATH
const JZGW_PATH = process.env.JZGW_PATH


// // 大数据埋点
// console.log('getToken',getToken())
var haveToken = getToken()

// console.log("ssoisLogin", sessionStorage.getItem('SET_ISLOGIN'))

router.beforeEach((to, from, next) => {
  // console.log("sso_to",to)
  // console.log("sso_from",from)
  //  如果没有token  先调用接口获取
  let toquery = to.query
  let token = toquery.token;
  // console.log("urltoken",token)
  if(token) {
    // console.log("urltoken",token)
    setToken(token)
    // console.log("toen设置"+token)
  }
  else {
    token = getToken();
  }
  
  // console.log("getToken()",getToken())
  var tonkenInterval = setInterval(() => {
    if(token){
      clearInterval(tonkenInterval);
    }
    else {
      //  从服务器获取token
      store.dispatch('findToken').then(res => {
      clearInterval(tonkenInterval);
      }).catch(() => {
      })
    }
   }, 100);
  
   let topath = to.path
  //  console.log('sso_topath', topath)
 
  //  console.log('sso_toquery',toquery)
   let redirectUrl =  secret.decryptText(toquery.redirectUrl)
  //  console.log('sso_redirectUrl', redirectUrl)

   if (redirectUrl){
     setRedirectUrl(redirectUrl) 
   }
   //  是否需要登录
   if(topath == '/' || topath == '/login' || topath == '/mobileLogin'){
    //  console.log("进入1")
     next();
   }
  else {
    // console.log("进入2")
     // 需要登录
     //  验证用户是否已经登录
     var isLogin = sessionStorage.getItem('SET_ISLOGIN')
    //  console.log('isLogin',isLogin)
     if(isLogin == 'waite' || isLogin == null){
        // console.log("进入3")
        var loginTimer = setInterval(()=>{
          next();
        },100)
     } 
     else if(isLogin){
      // console.log('isLogin1',isLogin)
      // console.log("进入4")
      clearInterval(loginTimer)
      next();
     }
    else {
      // console.log("进入5")
       next({path:topath});
     }
   }
})

/** 导航栏选中 */
function navToolbarChecked (path) {
  if (path === '/indexs') {
    store.commit('SET_ISACTIVE', 0)
  } else if (path === '/tradition') {
    store.commit('SET_ISACTIVE', 1)
  } else if (path === '/design') {
    store.commit('SET_ISACTIVE', 2)
  } else if (path === '/bexam') {
    store.commit('SET_ISACTIVE', 3)
  } else if (path === '/bim') {
    store.commit('SET_ISACTIVE', 4)
  } else if (path === '/garden') {
    store.commit('SET_ISACTIVE', 5)
  } else if (path === '/interiordesign') {
    store.commit('SET_ISACTIVE', 6)
  } else if (path === '/build') {
    store.commit('SET_ISACTIVE', 7)
  } 
  // else if (path === '/personalHome') {
  //   store.commit('SET_ISACTIVE', 8)
  // } 
  else if (path === '/personalInfo') {
    store.commit('SET_ISACTIVE', 9)
  } else if (path === '/personalSafe') {
    store.commit('SET_ISACTIVE', 10)
  } else if (path === '/address') {
    store.commit('SET_ISACTIVE', 11)
  } 
  else if (path === '/index') {
    store.commit('SET_ISACTIVE', 12)
  }
}



// WEBPACK FOOTER //
// ./src/permission.js